import { Field, getIn, FieldProps } from "formik";
import { dissoc } from "ramda";

import { Switch, SwitchProps } from "src/components/Switch";

export interface FormikSwitchProps extends Omit<SwitchProps, "name"> {
  /** Formik field name. */
  name: string;
  /** Callback fired when the checked state changes. Also supports onChange for compatibility. */
  onChange?: () => void;
}

const FormikSwitch = ({
  name,
  onCheckedChange: onCheckedChangeProp,
  onChange: onChangeProp,
  ...rest
}: FormikSwitchProps) => (
  <Field name={name}>
    {({ field, meta: { error }, form }: FieldProps) => {
      const { status = {}, setStatus } = form;
      const fieldStatus = getIn(status, name);

      return (
        <Switch
          checked={!!field.value}
          error={error || fieldStatus}
          name={field.name}
          onBlur={field.onBlur}
          onCheckedChange={(checked: boolean) => {
            setStatus(dissoc(name, status));
            form.setFieldValue(name, checked);
            onCheckedChangeProp?.(checked);
            onChangeProp?.();
          }}
          {...rest}
        />
      );
    }}
  </Field>
);

FormikSwitch.displayName = "FormikSwitch";

export { FormikSwitch };
